import { render, staticRenderFns } from "./DeleteTagDialog.vue?vue&type=template&id=663ee1a0&scoped=true&"
import script from "./DeleteTagDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteTagDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteTagDialog.vue?vue&type=style&index=0&id=663ee1a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663ee1a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDialog,VRow,VSpacer})
